module.exports = __webpack_public_path__ + "static/media/private-cremation-eh.499645f8.png";